import { render, staticRenderFns } from "./shouruSG.vue?vue&type=template&id=09455571&scoped=true&"
import script from "./shouruSG.vue?vue&type=script&lang=js&"
export * from "./shouruSG.vue?vue&type=script&lang=js&"
import style0 from "./shouruSG.vue?vue&type=style&index=0&id=09455571&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09455571",
  null
  
)

export default component.exports